module.exports = __webpack_public_path__ + "assets/b89ad6b1ec9025e606ce4364f4de4689.jpg";